<template>
  <span class="d-flex flex-column justify-start">
    <UiText :variant="text ? 'body-4' : 'body-3'" class="text-start">
      <AppTranslate :identifier="label" />
    </UiText>
    <UiText v-if="text" variant="body-3" :color="color" class="label-text">
      {{ text }}
    </UiText>
  </span>
</template>

<script setup lang="ts">
import { UiText } from '../UiText';
import { AppTranslate } from '~/infrastructure';

interface Props {
  label: string;
  text?: string;
  color?: string;
}

withDefaults(defineProps<Props>(), {
  color: 'black',
  text: undefined,
});
</script>

<style lang="scss" scoped>
.label-text {
  position: relative;
  top: -4px;
}
</style>
